<div fxFlex>
  <form [formGroup]="form"> 
    <mat-form-field class="width-100">
      <input 
        matInput 
        #dropdownInput
        formControlName="dropdown"
        [matAutocomplete]="dropdownAC" 
        [placeholder]="dropdownLabel"
        (blur)="checkAutocompleteObject(form, 'dropdown')"
        (focus)="!dropdownAC.isOpen && getInitialValues()" 
        [required]="isRequired"
        >

      <mat-icon 
        matSuffix 
        svgIcon="close-circle-outline"
        [class.disable]="disabled"
        *ngIf="(dropdownInput.value && dropdownInput.value != 'All')" 
        (click)="dropdownInput.blur(); clearForm($event, form, 'dropdown')"
        >
      </mat-icon>

      <mat-icon 
        matSuffix 
        svgIcon="menu-down" 
        *ngIf="!(dropdownInput.value && dropdownInput.value != 'All')"
        >
      </mat-icon>

      <mat-autocomplete 
        [displayWith]="displayFn"
        #dropdownAC="matAutocomplete"
        (closed)="autoCmpltClosed(); dropdownInput.blur()" 
        (opened)="autocompleteScroll('dropdown', 'dropdownACRef', 'dropdownACTr')"
        >

        <mat-option 
          disabled
          *ngIf="loading[dropdownType]" 
          >
          <mat-spinner 
            color="primary" 
            [diameter]="45"
            class="margin-0au" 
            mode="indeterminate" 
            >
          </mat-spinner>
        </mat-option>

        <mat-option *ngIf="!loading[dropdownType] && !getMore && !listData.length" disabled>
          {{ 'MSG_ERROR_DATA_NOT_FOUND' | translate }}
        </mat-option>

        <mat-option *ngFor="let data of listData" [value]="data">
          {{ displayFn(data) }}
        </mat-option>
      </mat-autocomplete>

      <mat-error *ngIf="form.get('dropdown').hasError('required')">
        {{ 'MSG_FIELD_REQUIRED' | translate }}
      </mat-error>

      <mat-error *ngIf="form.get('dropdown').hasError('notExisting')">
        {{ 'MSG_DOESNT_EXIST' | translate:{type: doesntExistLabel | titlecase} }}
      </mat-error>
    </mat-form-field>
  </form>
</div>